import { useConfig } from '../../ConfigContext';
import { computeOverlay } from '../../../utils/overlayMath';
import { useEffect, useRef, useState } from 'react';

export default function BoardImage() {
  const { general, size, setSize } = useConfig();
  const pluginUrl = window.GBCONF ? window.GBCONF.pluginUrl : '';
  const boardImgUrl = pluginUrl + 'novy_nahled.jpg';
  const boardImgUrlH = pluginUrl + 'novy_nahledHnew.png';
  const imgRef = useRef(null);

  const updateSize = () => {
    if (imgRef.current) {
      setSize({
        width: imgRef.current.clientWidth,
        height: imgRef.current.clientHeight,
      });
    }
  };
  useEffect(() => {
    const img = imgRef.current;
    if (img && img.complete) {
      updateSize();
    } else if (img) {
      img.addEventListener('load', updateSize);
    }
    window.addEventListener('resize', updateSize);
    return () => {
      if (img) img.removeEventListener('load', updateSize);
      window.removeEventListener('resize', updateSize);
    };
  }, []);

  useEffect(() => {
    updateSize();
  }, [general.glassType, general.orientationHorizontal]);

  const finalSrc =
    general.orientationHorizontal &&
    (general.glassType === 'classic' ||
      general.glassType === 'pair' ||
      general.glassType === 'multiple')
      ? boardImgUrlH
      : boardImgUrl;
  return (
    <img
      ref={imgRef}
      src={finalSrc}
      alt="Skleněná deska"
      className="w-full h-full object-contain object-center deska-pozadi"
      style={{
        zIndex: 1,
        pointerEvents: 'none',
        userSelect: 'none',
        maxWidth: '850px',
        width: '100%',
      }}
      draggable={false}
    />
  );
}
